<template>
	<div>
		<mainHead :title="mainHeadTitle" :crumbsList="crumbsList"></mainHead>
		<div class="mainBox">
			<div class="titleTips">设置账号信息</div>
			<div class="inputRow flex_start" >
				<div class="inputTips">账号：</div>
				<div class="infoContent">{{formdata.username}}</div>
			</div>
			<div class="inputRow flex_start" >
				<div class="inputTips">姓名：</div>
				<div class="screenInput">
					<el-input class="inputWidth" size="small" placeholder="请输入密码" v-model="formdata.name" clearable></el-input>
				</div>
			</div>
			<div class="inputRow flex_start" >
				<div class="inputTips">电话：</div>
				<div class="screenInput">
					<el-input class="inputWidth" type="number" size="small" placeholder="请输入密码" v-model="formdata.phone" clearable></el-input>
				</div>
			</div>
			<div class="flex_start">
				<div class="inputRow flex_start">
					<div class="inputTips">上传头像：</div>
					<el-upload class="upload-demo" ref="upload"
						action="http://192.168.1.110/admin/admin.AdminManage/authImport"
						:on-change="function (res,file){return onChange(res,file)}" :auto-upload="false"
						:show-file-list="false">
						<img class="upload_img" v-if="avatar_image" :src="avatar_image">
						<!-- <img v-else src="../../../assets/home/logo.png" class="avatar"> -->
						<span class="addImg flex_center" v-else><img src="../../assets/add.png" alt=""></span>
					</el-upload>
				</div>
			</div>
			<!-- <div class="inputRow flex_start">
				<div class="inputTips">新密码：</div>
				<div class="screenInput">
					<el-input class="inputWidth" type="password" size="small" placeholder="请输入密码" v-model="password" clearable></el-input>
				</div>
			</div>
			<div class="inputRow flex_start">
				<div class="inputTips">确认新密码：</div>
				<div class="screenInput">
					<el-input class="inputWidth" type="password" size="small" placeholder="请输入密码" v-model="repeatPassword" clearable></el-input>
				</div>
			</div> -->
			<!-- <div class="flex_start">
				<div class="inputRow flex_start" >
					<div class="inputTips">信息补充：</div>
					<div class="richText">
					    <el-input size="medium" type="textarea" placeholder="房产证号，印花税票，以及编号,地址，产权人，面积" v-model="formdata.room_note" resize="none"
					    	:autosize="{ minRows: 3, maxRows: 6}"></el-input>
					</div>
				</div>
				<div class="inputRow flex_start">
					<div class="inputTips">房产产权：</div>
					<div class="screenInput flex_start" style="margin-top: 2px;">
						<el-radio-group v-model="formdata.room_rights">
							<el-radio :label="1">40年</el-radio>
							<el-radio :label="2">50年</el-radio>
							<el-radio :label="3">70年</el-radio>
						</el-radio-group>
					</div>
				</div>
			</div> -->
			
			<div class="btnList flex_start">
				<div class="screenBtn" @click="confirm"><el-button size="medium" type="primary">保存</el-button></div>
				<!-- <div class="screenBtn" @click="cancal"><el-button size="medium" type="info">返回</el-button></div> -->
			</div>
		</div>
	</div>
</template>

<script>
	export default{
		data() {
			return{
				mainHeadTitle:'账号信息',
				crumbsList:['账号信息'],
				// password:'',
				// repeatPassword:'',
				// followTypeList:[],
				formdata:{
					name:'',
					phone:''
				},
				avatar_image:'',//缩略图上传回显
				avatar:'',//缩略图上传
			}
		},
		mounted() {
			this.getUserData();
		},
		methods:{
			//点击提交
			confirm(){
				// this.formdata['user_id'] = this.id
				this.formdata['type'] = 'memberDetail'
				if(this.avatar){
					this.formdata['avatar'] = this.avatar
				}
				if(!this.formdata.name){
					this.$message({
					    message: '请输入姓名',
					     type: 'warning'
					});
					return
				}
				if(!this.formdata.phone){
					this.$message({
					    message: '请输入电话号码',
					     type: 'warning'
					});
					return
				}
				const reg = /^1[3456789]\d{9}$/;
				if(!reg.test(this.formdata.phone)){
					this.$message({
						type:'warning',
						message:'请输入正确的手机号码'
					})
					return
				}
				// let data = {type:'memberDetail',password:this.password,avatar:this.avatar}
				this.$http.post(this.$api.user,this.formdata).then(res => {
					console.log(res);
					if(this.avatar_image){
						this.$store.commit('changeAvatar',this.avatar_image);
					}
					if (res.code == 200) {
						this.$message({
						    message: '保存成功',
						     type: 'success'
						});
						this.getUserData();
					}else{
						this.$message({
						    message: res.msg,
						     type: 'error'
						});
					}
				})
			},
			// 获取账号信息
			getUserData() {
				let data = {type:'memberInfo'}
				this.$http.post(this.$api.user,data).then(res => {
					console.log(res);
					if (res.code == 200) {
						this.formdata = res.data
						if(res.data.avatar){
							this.avatar_image = res.data.avatar_image
							this.avatar = res.data.avatar
						}
					}
				})
			},
			//获取房产类别列表
			getroomTypeList(){
				let data = {type:'roomType'}
				this.$http.post(this.$api.user,data).then(res => {
					console.log(res);
					if (res.code == 200) {
						this.followTypeList = res.data
					}
				})
			},
			//上传图片
			onChange(file, fileList) {
				let formdata = new FormData;
				// formdata.append('type', 'uploadPicture')
				formdata.append('img', file.raw)
				formdata.append('type', 'picture')
				formdata.append('token', localStorage.getItem('token-bank'))
				this.$http.post(this.$api.navList, formdata).then(res => {
					console.log(res)
					if(res.code==200){
						this.avatar_image = res.data.image
						this.avatar = res.data.img
					}else{
						this.$message({
							message: res.msg,
							type: 'warning'
						});
					}
				})
			},
		}
	}
</script>

<style scoped>
	.mainBox{
		padding: 20px;
		box-sizing: border-box;
		width: 100%;
		box-shadow: 0 3px 15px rgb(0 0 0 / 5%);
		margin-top: 30px;
		background: #FFFFFF;
	}
	.titleTips{
		font-size: 18px;
		font-weight: 600;
		margin-bottom: 10px;
	}

	
	
	.inputRow{
		margin: 10px 0;
		width: 46%;
	}
	.inputTips{
		width: 130px;
		line-height: 32px;
		/* padding-left: 15px; */
		box-sizing: border-box;
		font-size: 14px;
	}
	.infoContent{
		line-height: 32px;
		font-size: 14px;
	}
	.unitText{
		font-size: 14px;
		line-height: 32px;
		margin: 0 10px;
	}
	.screenInput{
		align-items: center;
		height: 32px;
		/* min-width: 300px; */
	}
	.richText{
		width: 500px;
		margin-top: 5px;
	}
	
	.btnList{
		margin: 15px 0;
		margin-top: 30px;
	}
	.screenBtn{
		margin-left: 130px;
	}
	.addImg{
		width: 100px;
		height: 100px;
		border: 1px dashed #eee;
		margin: 10px 0;
		align-items: center;
	}
	.addImg img{
		width: 16px;
		height: 16px;
	}
	.upload_img{
		width: 100px;
		height: 100px;
		margin: 10px 0;
	}
</style>
